(function() {
  'use strict';

  // ── DISABLED — Klaviyo form in use. Remove the two lines below to re-enable. ──
  return;

  // ── CONFIG ──────────────────────────────────────────────
  var DELAY_MS        = 4000;
  var SCROLL_PCT      = 35;
  var STORAGE_KEY     = 'sb_popup_v4';
  var PROMO_CODE      = 'WELCOME10';
  var API             = 'https://email.silverbackgymwear.com/api/subscribe';
  var FONTS           = 'https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@800;900&family=Barlow:wght@400;500&display=swap&v=2';
  // ────────────────────────────────────────────────────────

  // ── Bulletproof storage ─────────────────────────────────
  var storage = {
    data: null,
    init: function() {
      // Try to read from any available storage
      var sources = [
        function() { return localStorage.getItem(STORAGE_KEY); },
        function() { return sessionStorage.getItem(STORAGE_KEY); },
        function() { 
          var m = document.cookie.match(new RegExp('(^|;)\\s*' + STORAGE_KEY + '=([^;]+)'));
          return m ? decodeURIComponent(m[2]) : null;
        }
      ];
      for (var i = 0; i < sources.length; i++) {
        try {
          var val = sources[i]();
          if (val) { this.data = JSON.parse(val); break; }
        } catch(e) {}
      }
      if (!this.data) this.data = {};
    },
    save: function() {
      var val = JSON.stringify(this.data);
      // Try all storage methods
      try { localStorage.setItem(STORAGE_KEY, val); } catch(e) {}
      try { sessionStorage.setItem(STORAGE_KEY, val); } catch(e) {}
      try {
        var expires = new Date(Date.now() + 7 * 86400000).toUTCString();
        document.cookie = STORAGE_KEY + '=' + encodeURIComponent(val) + ';expires=' + expires + ';path=/;SameSite=Lax';
      } catch(e) {}
    },
    isSuppressed: function() {
      return this.data.hide && Date.now() < this.data.hide;
    },
    isSubscribed: function() {
      return this.data.subscribed === true;
    },
    suppress: function(days) {
      this.data.hide = Date.now() + (days * 86400000);
      this.save();
    },
    markSubscribed: function() {
      this.data.subscribed = true;
      this.save();
    },
    clear: function() {
      this.data = {};
      this.save();
    }
  };
  
  storage.init();

  // ── Early exits ─────────────────────────────────────────
  if (storage.isSubscribed()) return;
  if (window.Shopify && window.Shopify.customer) return;
  if (/checkout|thank.you|account|cart|password/i.test(location.pathname)) return;
  
  // ── Locale ──────────────────────────────────────────────
  var isFR = /^\/fr(\/|$)/i.test(location.pathname) || 
             document.documentElement.lang === 'fr';
  var SHOP_URL = isFR
    ? 'https://silverbackgymwear.com/fr/discount/WELCOME10'
    : 'https://silverbackgymwear.com/discount/WELCOME10';

  var T = {
    en: {
      eyebrow: 'Join the Pack',
      headline: 'GET 10% OFF<br>YOUR FIRST ORDER.',
      sub: 'Subscribe for exclusive drops, training tips, and <strong>10% off your first order</strong>.',
      pill: '10% OFF — CODE WELCOME10',
      fname: 'First name (optional)',
      email: 'Your email address *',
      emailErr: 'Please enter a valid email address.',
      cta: 'CLAIM MY 10% →',
      privacy: 'No spam, ever. Unsubscribe anytime.',
      privacyLink: 'Privacy Policy',
      okHeadline: 'YOU\'RE IN<br>THE PACK.',
      okSub: 'Check your inbox — your 10% discount is on its way.',
      okSubName: 'Welcome, {name}. Check your inbox — your discount is on its way.',
      codeLabel: 'Your discount code',
      codeHint: 'TAP TO COPY — WE\'LL TAKE YOU TO THE SHOP',
      toast: 'CODE COPIED ✓',
      errGeneric: 'Something went wrong. Please try again.',
      reopenLabel: '10% OFF'
    },
    fr: {
      eyebrow: 'Rejoins la Meute',
      headline: '10% DE RÉDUC<br/>SUR TA 1ÈRE COMMANDE.',
      sub: 'Inscris-toi pour des exclus, des conseils, et <strong>10% de réduction</strong>.',
      pill: '10% DE RÉDUCTION — CODE WELCOME10',
      fname: 'Prénom (optionnel)',
      email: 'Votre adresse e-mail *',
      emailErr: 'Veuillez saisir une adresse e-mail valide.',
      cta: 'RÉCLAMER MES 10% →',
      privacy: 'Zéro spam. Désinscription à tout moment.',
      privacyLink: 'Politique de confidentialité',
      okHeadline: 'TU ES DANS<br>LA MEUTE.',
      okSub: 'Vérifie ta boîte de réception — ta réduction arrive.',
      okSubName: 'Bienvenue, {name}. Vérifie ta boîte de réception — ta réduction arrive.',
      codeLabel: 'Ton code de réduction',
      codeHint: 'APPUIE POUR COPIER — ON T\'AMÈNE EN BOUTIQUE',
      toast: 'CODE COPIÉ ✓',
      errGeneric: 'Quelque chose s\'est mal passé. Réessaie.',
      reopenLabel: '10% DE RÉDUC'
    }
  };
  var L = isFR ? T.fr : T.en;

  // ── Styles ──────────────────────────────────────────────
  var css = document.createElement('style');
  css.textContent = [
    '#sb-popup-overlay{position:fixed;inset:0;background:rgba(0,0,0,.78);z-index:999998;display:none;align-items:center;justify-content:center;padding:16px;opacity:0;transition:opacity .35s}',
    '#sb-popup-overlay.sb-vis{display:flex;opacity:1}',
    '#sb-popup-box{position:relative;background:#0a0a0a;border:1px solid rgba(255,255,255,.12);max-width:480px;width:100%;padding:52px 44px;text-align:center;font-family:Barlow,sans-serif;transform:translateY(24px);transition:transform .35s}',
    '#sb-popup-overlay.sb-vis #sb-popup-box{transform:translateY(0)}',
    '#sb-popup-close{position:absolute;top:12px;right:12px;background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.2);color:#fff;font-size:32px;cursor:pointer;padding:10px 16px;border-radius:8px;line-height:1;transition:all .2s}',
    '#sb-popup-close:hover{background:rgba(255,255,255,0.2);border-color:rgba(255,255,255,0.4)}',
    '.sb-pu-eye{font-family:"Barlow Condensed",Arial,sans-serif;font-size:12px;font-weight:800;letter-spacing:4px;text-transform:uppercase;color:#666;margin:0 0 12px}',
    '.sb-pu-h{font-family:"Barlow Condensed",Arial,sans-serif;font-size:42px;font-weight:900;line-height:1;text-transform:uppercase;color:#fff;margin:0 0 14px}',
    '.sb-pu-sub{font-size:15px;color:#999;line-height:1.6;margin:0 0 24px}',
    '.sb-pu-sub strong{color:#fff;font-weight:500}',
    '.sb-pu-pill{display:inline-block;background:#fff;color:#000;font-family:"Barlow Condensed",Arial,sans-serif;font-size:16px;font-weight:800;text-transform:uppercase;padding:7px 18px;margin:0 0 28px}',
    '.sb-pu-in{display:block;width:100%;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.4);color:#fff;font-family:Barlow,sans-serif;font-size:15px;padding:14px 16px;box-sizing:border-box;outline:none;margin-bottom:10px}',
    '.sb-pu-in::placeholder{color:#888}',
    '.sb-pu-in:focus{border-color:rgba(255,255,255,.4)}',
    '.sb-pu-in.err{border-color:#ff4444}',
    '.sb-pu-err{color:#ff4444;font-size:12px;text-align:left;margin:-6px 0 10px;display:none}',
    '.sb-pu-btn{display:block;width:100%;background:#fff;color:#000;border:2px solid #fff;font-family:"Barlow Condensed",Arial,sans-serif;font-size:22px;font-weight:800;text-transform:uppercase;padding:18px;cursor:pointer;margin-top:4px}',
    '.sb-pu-btn:hover{background:#e8e8e8}',
    '.sb-pu-btn:disabled{background:#222;color:#555;cursor:not-allowed}',
    '.sb-pu-priv{font-size:11px;color:#444;margin-top:14px}',
    '.sb-pu-priv a{color:#555}',
    '.sb-pu-ok{display:none}',
    '.sb-pu-ok-h{font-family:"Barlow Condensed",Arial,sans-serif;font-size:38px;font-weight:900;text-transform:uppercase;color:#fff;margin:0 0 12px}',
    '.sb-pu-code{font-family:"Barlow Condensed",Arial,sans-serif;font-size:36px;font-weight:800;letter-spacing:4px;color:#fff;cursor:pointer;margin:16px 0}',
    '.sb-pu-tab{position:fixed;left:0;top:50%;transform:translateY(-50%) translateX(-100%);background:#0a0a0a;border:1px solid rgba(255,255,255,.15);border-left:none;padding:18px 12px;cursor:pointer;z-index:99999;font-family:"Barlow Condensed",Arial,sans-serif;font-size:15px;font-weight:800;letter-spacing:1.5px;text-transform:uppercase;color:#fff;writing-mode:vertical-lr;transform-origin:center;border-radius:0 10px 10px 0;transition:transform .3s;box-shadow:3px 0 12px rgba(0,0,0,.35)}',
    '.sb-pu-tab.sb-vis{transform:translateY(-50%) translateX(0)}',
    '.sb-pu-tab:hover{background:#1a1a1a}',
    '@media (max-width:600px){#sb-popup-close{font-size:36px;padding:12px 20px;top:8px;right:8px;border-radius:10px}}'
  ].join('');
  document.head.appendChild(css);

  // ── Load Google Fonts ───────────────────────────────────
  var fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = FONTS;
  document.head.appendChild(fontLink);

  // ── Build DOM ───────────────────────────────────────────
  var overlay = document.createElement('div');
  overlay.id = 'sb-popup-overlay';
  overlay.innerHTML = [
    '<div id="sb-popup-box">',
    '<button id="sb-popup-close" aria-label="Close popup">&times;</button>',
    '<div id="sb-popup-form">',
    '<p class="sb-pu-eye">' + L.eyebrow + '</p>',
    '<h2 class="sb-pu-h">' + L.headline + '</h2>',
    '<p class="sb-pu-sub">' + L.sub + '</p>',
    '<div class="sb-pu-pill">' + L.pill + '</div>',
    '<input id="sb-pu-fn" class="sb-pu-in" placeholder="' + L.fname + '">',
    '<input id="sb-pu-em" class="sb-pu-in" type="email" placeholder="' + L.email + '">',
    '<p id="sb-pu-err" class="sb-pu-err">' + L.emailErr + '</p>',
    '<button id="sb-pu-submit" class="sb-pu-btn">' + L.cta + '</button>',
    '<p class="sb-pu-priv">' + L.privacy + ' <a href="/pages/privacy-policy" target="_blank">' + L.privacyLink + '</a></p>',
    '</div>',
    '<div id="sb-popup-ok" class="sb-pu-ok">',
    '<h3 class="sb-pu-ok-h">' + L.okHeadline + '</h3>',
    '<p class="sb-pu-sub">' + L.okSub + '</p>',
    '<p class="sb-pu-code">' + PROMO_CODE + '</p>',
    '</div>',
    '</div>'
  ].join('');
  document.body.appendChild(overlay);

  var tab = document.createElement('div');
  tab.className = 'sb-pu-tab';
  tab.textContent = L.reopenLabel;
  document.body.appendChild(tab);

  // ── State & functions ───────────────────────────────────
  var hasShown = false;
  var suppressTimer = null;

  function showPopup() {
    if (hasShown) return;
    hasShown = true;
    overlay.style.display = 'flex';
    tab.classList.remove('sb-vis');
    setTimeout(function() { overlay.classList.add('sb-vis'); }, 10);
  }

  function hidePopup() {
    overlay.classList.remove('sb-vis');
    setTimeout(function() { 
      overlay.style.display = 'none'; 
      tab.classList.add('sb-vis');
    }, 350);
  }

  // ── Event handlers ──────────────────────────────────────
  document.getElementById('sb-popup-close').addEventListener('click', function() {
    hidePopup();
    storage.suppress(7);
    if (suppressTimer) clearTimeout(suppressTimer);
  });

  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) {
      hidePopup();
      storage.suppress(7);
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.style.display === 'flex') {
      hidePopup();
      storage.suppress(7);
    }
  });

  tab.addEventListener('click', function() {
    storage.clear();
    hasShown = false;
    showPopup();
  });

  // ── Form submit ─────────────────────────────────────────
  document.getElementById('sb-pu-submit').addEventListener('click', function() {
    var email = document.getElementById('sb-pu-em').value.trim();
    var fname = document.getElementById('sb-pu-fn').value.trim();
    var errEl = document.getElementById('sb-pu-err');
    var btn = document.getElementById('sb-pu-submit');

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      document.getElementById('sb-pu-em').classList.add('err');
      errEl.style.display = 'block';
      return;
    }

    btn.disabled = true;
    btn.textContent = '...';

    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email, firstName: fname, locale: isFR ? 'fr' : 'en', source: 'welcome-popup' })
    })
    .then(function(r) { return r.json().then(function(d) { return { ok: r.ok, d: d }; }); })
    .then(function(r) {
      if (r.ok) {
        document.getElementById('sb-popup-form').style.display = 'none';
        document.getElementById('sb-popup-ok').style.display = 'block';
        storage.markSubscribed();
        tab.style.display = 'none';
      } else {
        btn.disabled = false;
        btn.textContent = L.cta;
        errEl.textContent = L.errGeneric;
        errEl.style.display = 'block';
      }
    })
    .catch(function() {
      btn.disabled = false;
      btn.textContent = L.cta;
      errEl.textContent = L.errGeneric;
      errEl.style.display = 'block';
    });
  });

  document.getElementById('sb-pu-em').addEventListener('input', function() {
    this.classList.remove('err');
    document.getElementById('sb-pu-err').style.display = 'none';
  });

  // ── Copy code ───────────────────────────────────────────
  document.querySelector('.sb-pu-code').addEventListener('click', function() {
    try { navigator.clipboard.writeText(PROMO_CODE); } catch(e) {
      var x = document.createElement('textarea');
      x.value = PROMO_CODE;
      document.body.appendChild(x);
      x.select();
      document.execCommand('copy');
      document.body.removeChild(x);
    }
    window.location.href = SHOP_URL;
  });

  // ── Show tab always ─────────────────────────────────────
  tab.classList.add('sb-vis');

  // ── Auto-show if not suppressed ────────────────────────
  if (!storage.isSuppressed()) {
    suppressTimer = setTimeout(showPopup, DELAY_MS);
    
    function onScroll() {
      var doc = document.documentElement;
      var pct = (window.scrollY || doc.scrollTop) / ((doc.scrollHeight - doc.clientHeight) || 1) * 100;
      if (pct >= SCROLL_PCT) showPopup();
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    if (!/Mobi|Android/i.test(navigator.userAgent)) {
      window.addEventListener('mouseleave', function(e) {
        if (e.clientY <= 20) showPopup();
      });
    }
  }

})();